export function assessmentToolText(tool) {
  switch (tool) {
    case "Story":
      return `
      <p>Use the Story Assessment Tool to record stories about your sustainability work so far.</p>
      <p>This is useful when:</p>
      <ul>
        <li>
          You plan to showcase where you are today through stories only (not data), <b><u>OR</u></b>
        </li>
        <li>
          You have or plan to use data assessment tool, but you also have some great stories you want to tell <b><u>OR</u></b>
        </li>
        <li>
          You plan to report data in the future, but right now you just have stories to use as your baseline
        </li>
      </ul>
      `;
    case "Data":
      return `
      <p>Use the Data Assessment Tool for outcomes where you want to</p>
      <ul>
        <li>
          Track your data
        </li>
        <li>
          View Data Summaries of this outcome
        </li>
        <li>
          Set data goals
        </li>
        <li>
          Receive data reporting
        </li>
      </ul>
      <p>We start your process by getting you to answer some brief questions that automatically customise the data table to enable you to focus on what data you need to provide. We also suggest the best places to find the data you need to report.</p>
      `;
    case "Scale":
      return `
      <p>	Use the Scale Assessment Tool for outcomes where you want to</p>
      <ul>
        <li>
          See where you stand in relation to best-practice for an outcome
        </li>
        <li>
          Get a fresh insight that goes beyond stories or other tools
        </li>
        <li>
          Discover areas needing improvement and focus on these in developing your plan
        </li>
      </ul>
      `;
    default:
      return "";
  }
}
